module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-slider-6.jpg?76174a34";